const routes = [
  {
    name: 'teaAgentEntryLink',
    path: '/tea-agent/pages/entry/link',
    component: () => import('@pages/tea-agent/entry/link'),
  },
  {
    name: 'teaAgentEntryList',
    path: '/tea-agent/pages/entry/list',
    component: () => import('@pages/tea-agent/entry/list'),
  },
  {
    name: 'teaAgentAllocatedAuth',
    path: '/tea-agent/pages/allocated/auth',
    component: () => import('@pages/tea-agent/allocated/auth'),
  },
  {
    name: 'teaAgentAllocated',
    path: '/tea-agent/allocated',
    component: () => import('@pages/tea-agent/allocated'),
  },
  {
    name: 'teaAgentCenter',
    path: '/tea-agent/center',
    component: () => import('@pages/tea-agent/center'),
  },
  {
    name: 'teaAgentComendProgress',
    path: '/tea-agent/comend-progress',
    component: () => import('@pages/tea-agent/comend/comend-progress'),
  },
  {
    name: 'teaAgentError',
    path: '/tea-agent/error',
    component: () => import('@pages/tea-agent/error'),
  },
  {
    name: 'teaAgentIncomeDetails',
    path: '/tea-agent/income-details',
    component: () => import('@pages/tea-agent/income-details'),
  },
  {
    name: 'teaAgentIncomeSharePage',
    path: '/tea-agent/pages/invite/share-page',
    component: () => import('@pages/tea-agent/invite/share-page'),
  },
  {
    name: 'teaAgentLogin',
    path: '/tea-agent/login/login',
    component: () => import('@pages/tea-agent/login/login'),
  },
  {
    name: 'teaAgentForget',
    path: '/tea-agent/login/forget',
    component: () => import('@pages/tea-agent/login/forget'),
  },
  {
    name: 'teaAgentRegest',
    path: '/tea-agent/login/regest',
    component: () => import('@pages/tea-agent/login/regest'),
  },
  {
    name: 'teaAgentSupply',
    path: '/tea-agent/login/supply',
    component: () => import('@pages/tea-agent/login/supply'),
  },
  {
    name: 'teaAgentPay',
    path: '/tea-agent/pay/pay',
    component: () => import('@pages/tea-agent/pay/pay'),
  },
  {
    name: 'teaAgentRule',
    path: '/tea-agent/rule/rule',
    component: () => import('@pages/tea-agent/rule/rule'),
  },
  {
    name: 'teaAgentStrategy',
    path: '/tea-agent/rule/strategy',
    component: () => import('@pages/tea-agent/rule/strategy'),
  },
];

export default routes;
